import { MoveHorizontal, Share2 } from "lucide-react";
import { FC, useState } from "react";
import { ConsolidateInventory } from "../consolidate";
import { DeconsolidateInventory } from "../deconsolidate";

type Props = {};

export const ConsolidationActions: FC<Props> = () => {
  const [showConsolidateModal, setShowConsolidateModal] = useState(false);
  const [showDeconsolidateModal, setShowDeconsolidateModal] = useState(false);

  const openConsolidate = () => {
    setShowConsolidateModal(true);
  };
  const closeConsolidate = () => {
    setShowConsolidateModal(false);
  };
  const openDeconsolidate = () => {
    setShowDeconsolidateModal(true);
  };
  const closeDeconsolidate = () => {
    setShowDeconsolidateModal(false);
  };
  return (
    <>
      <div className="mt-6">
        <div className="bg-white rounded-lg border p-4 shadow-sm">
          <div className="flex items-center justify-between">
            <div>
              <h3 className="font-medium">Inventory Actions</h3>
              <p className="text-sm text-gray-500 mt-1">
                Select items to perform batch actions
              </p>
            </div>
            <div className="flex space-x-3">
              <button
                onClick={openConsolidate}
                className="cursor-pointer px-4 py-2 flex items-center space-x-2 rounded-lg border bg-green-50 text-green-700 border-green-200 hover:bg-green-100"
              >
                <MoveHorizontal size={16} />
                <span>Consolidate</span>
              </button>
              <button
                className="px-4 py-2 flex items-center space-x-2 rounded-lg border bg-red-400 text-white cursor-pointer"
                onClick={openDeconsolidate}
              >
                <Share2 size={16} />
                <span>Deconsolidate</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <ConsolidateInventory
        open={showConsolidateModal}
        onClose={closeConsolidate}
      />

      <DeconsolidateInventory
        open={showDeconsolidateModal}
        onCancel={closeDeconsolidate}
      />
    </>
  );
};
